import { render } from "./NewReleasesCarousel.vue?vue&type=template&id=602e138c&scoped=true"
import script from "./NewReleasesCarousel.vue?vue&type=script&lang=js"
export * from "./NewReleasesCarousel.vue?vue&type=script&lang=js"

import "./NewReleasesCarousel.vue?vue&type=style&index=0&id=602e138c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-602e138c"]])

export default __exports__